import React from "react";

const ADO_Connect = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Connect</h1>
      <p>This is the ADO Connect page content.</p>
    </div>
  );
};

export default ADO_Connect;
